export const community = {
  avatar: 'Profile picture of {{name}}',
  breadcrumb: {
    overview: 'Network',
  },
  detail: {
    disabled: 'This Shelterer’s profile is no longer public.',
    error: {
      title: 'Error loading the profile.',
    },
  },
  enableCommunityProfileDialog: {
    actions: {
      goToSettings: 'Make profile public',
    },
    description:
      'Would you like to ask a question on the forum, search for and find other freelancers, have you spotted an assignment that interests you, or would you like to post one yourself? <br/>Then a public Community profile is the way to go. You can change that quickly and easily via your profile.',
    title: 'Join our Community',
  },
  header: {
    preview: 'View your profile',
    title: 'Network',
  },
  infoCards: {
    activity: {
      action: 'Filter by your activities',
      description_one: '{{count}} freelancer shares your activities',
      description_other: '{{count}} freelancers share your activities',
      description_zero: 'No freelancers with the same activities yet',
      title: 'Freelancers with the same activities',
    },
    error: 'Couldn’t be loaded',
    profile: {
      action: 'Complete profile',
      description: 'Complete your profile as fully as possible and grow your network.',
      title: 'Make sure others can find you',
    },
    region: {
      action: 'Filter by your region',
      description_one: '{{count}} freelancer is active in your region',
      description_other: '{{count}} freelancers are active in your region',
      description_zero: 'No freelancers in your region yet',
      title: 'Freelancers in your region',
    },
  },
  overview: {
    errorLoading: 'Something went wrong while retrieving the network.',
    filters: {
      activity: {
        label: 'Activities',
      },
      name: {
        placeholder: 'Search by name',
      },
      openToWork: {
        text: 'Available for assignments',
      },
      region: {
        label: 'Region',
      },
    },
    loading: 'Loading data…',
    locked: {
      button: 'Make profile public',
      description: 'Make your profile public to become part of the Craft Community.',
      success: 'Your profile is now public. Welcome to the Craft Community!',
    },
    resultCount_one: '{{count}} result',
    resultCount_other: '{{count}} results',
    resultCount_zero: 'No match found based on your search criteria',
  },
  profileCard: {
    activeInRegion: 'Active in {{regions}}',
    footer: {
      behance: 'Behance',
      facebook: 'Facebook',
      instagram: 'Instagram',
      linkedIn: 'LinkedIn',
      mail: 'Email',
      website: 'Website',
    },
    openDialog: 'View profile of {{name}}',
    openToWork: 'Available',
  },
  regions: {
    Abroad: 'Abroad',
    Antwerp: 'Antwerp',
    Brussels: 'Brussels',
    EastFlanders: 'East Flanders',
    FlemishBrabant: 'Flemish Brabant',
    Hainaut: 'Hainaut',
    Liege: 'Liège',
    Limburg: 'Limburg',
    Luxembourg: 'Luxembourg',
    Namur: 'Namur',
    WalloonBrabant: 'Walloon Brabant',
    WestFlanders: 'West Flanders',
  },
};
